import React, {useState} from 'react'
import ReactTooltip from 'react-tooltip'
import { useHistory, useParams } from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import * as Actions from 'state/actions'
import {getSelectedState} from 'state/selectors'

import styled from '@emotion/styled'

import iconArchive from 'assets/icons/ico-archive.svg'
import iconArchiveActive from 'assets/icons/ico-archive-active.svg'
import iconAssign from 'assets/icons/ico-assign.svg'
import iconUnassign from 'assets/icons/ico-unassign.svg'
import iconDelete from 'assets/icons/ico-delete.svg'
import ActionLink from './ActionLink'



const IconBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Tooltip = styled(ReactTooltip)`
  color: #FFFFFF;
  background-color: #353A52;
  //border: 1px solid #90A1B0;
  box-shadow: 0 4px 16px rgba(53, 58, 82, 0.08);
  padding: 8px 16px;
  font-size: 12rem;
  font-family: inherit;
`

const IconBar = () => {
  const dispatch = useDispatch()
  const { 
    assigned, 
    archived 
  } = useSelector(getSelectedState).interaction

  const history = useHistory()
  const historyParams = useParams()
    
  const handleAssignInteraction = () => {
    if(!assigned) dispatch(Actions.assignInteraction())
    if(assigned) dispatch(Actions.unAssignInteraction())
  }
  const handleArchiveInteraction = () => {
    if(!archived) dispatch(Actions.archiveInteraction())
    if(archived) dispatch(Actions.unArchiveInteraction())
  }
  const handleDeleteInteraction = () => {
    history.push(`${process.env.CHAT_PUBLIC_PATH}/${historyParams.filterType}/${historyParams.filterId}`)
    dispatch(Actions.deleteInteraction())
  }
    
  return (
    <IconBarContainer>
      <ActionLink
        handleClick={handleAssignInteraction}
        tip={assigned ? 'Unassign from me' : 'Assign to me' }
        icon={assigned ? iconUnassign : iconAssign }
        tooltipId="dialogTooltip"
      />

      <ActionLink
        handleClick={handleArchiveInteraction}
        tip={archived ? 'Unarchive conversation' : 'Archive conversation'}
        icon={archived ? iconArchiveActive : iconArchive}
        tooltipId="dialogTooltip"
      />
      <ActionLink
        handleClick={handleDeleteInteraction}
        tip="Delete conversation"
        icon={iconDelete}
        tooltipId="dialogTooltip"
      />
      <Tooltip
        place="bottom"
        effect="solid"
        id="dialogTooltip"
        delayShow={400}
      />
    </IconBarContainer>
  )
}

export default IconBar
